import { stateOptions } from '../../commonStateTaxData';

export const basicInfoQuestions2022 = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address - number and street or rural route',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const withholdingQuestions2022 = [
  {
    id: 'percent_withheld',
    title: 'Withhold from gross taxable wages at the selected percentage: ',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: '08_percent',
        shortName: '0.8%',
      },
      {
        codeValue: '13_percent',
        shortName: '1.3%',
      },
      {
        codeValue: '18_percent',
        shortName: '1.8%',
      },
      {
        codeValue: '27_percent',
        shortName: '2.7%',
      },
      {
        codeValue: '36_percent',
        shortName: '3.6%',
      },
      {
        codeValue: '42_percent',
        shortName: '4.2%',
      },
      {
        codeValue: '51_percent',
        shortName: '5.1%',
      },
    ],
  },
  {
    id: 'extra_withholding',
    title: 'Extra amount to be withheld from each paycheck: ',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];
